var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlerticonstus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#D20A0A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.2187 33.2517L27.7737 13.4278C27.2636 12.5443 26.3209 12 25.3008 12C24.2806 12 23.3383 12.5443 22.8279 13.4278L11.3828 33.2517C10.8724 34.1355 10.8724 35.2235 11.3828 36.1072C11.8929 36.991 12.8356 37.535 13.8557 37.535H36.7462C37.7659 37.535 38.709 36.991 39.2191 36.1072C39.7291 35.2235 39.7291 34.1351 39.2187 33.2517ZM13.8557 34.6795L25.3008 14.8555L36.7458 34.6791L13.8557 34.6795Z",
    fill: "#D20A0A",
    fillOpacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8711 21.4497V27.4082C23.8711 28.1967 24.5104 28.836 25.2989 28.836C26.0874 28.836 26.7266 28.1967 26.7266 27.4082V21.4497C26.7266 20.6613 26.0874 20.022 25.2989 20.022C24.5104 20.022 23.8711 20.6613 23.8711 21.4497Z",
    fill: "#D20A0A",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2989 32.7872C26.0874 32.7872 26.7266 32.148 26.7266 31.3594C26.7266 30.5709 26.0874 29.9316 25.2989 29.9316C24.5103 29.9316 23.8711 30.5709 23.8711 31.3594C23.8711 32.148 24.5103 32.7872 25.2989 32.7872Z",
    fill: "#D20A0A",
    fillOpacity: 0.8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlerticonstus);
export default __webpack_public_path__ + "static/media/alerticonstus.2b941b221f58b6ba0cdbedb6a26841ff.svg";
export { ForwardRef as ReactComponent };